import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

const DOC = gql`
  mutation DeleteIntegrationConnector($tenantId: ID!, $zoneId: ID!, $id: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        deleteIntgConnector(id: $id)
      }
    }
  }
`

export const execute = graphql.createExecutor<
  graphql.schema.DeleteIntegrationConnectorMutation,
  void,
  graphql.schema.DeleteIntegrationConnectorMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
